import { Link } from "react-router-dom";
import { PageHeader } from "./ui/PageHeader.js";

const COPY = {
  list: { title: "List not found", href: "/lists", back: "Back to my lists" },
  template: { title: "Template not found", href: "/templates", back: "Back to my templates" },
  checklist: { title: "Checklist not found", href: "/checklists", back: "Back to my checklists" },
} as const;

export function ResourceNotFound({ kind }: { kind: "list" | "template" | "checklist" }) {
  const copy = COPY[kind];
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-8 sm:py-10">
      <PageHeader
        title={copy.title}
        subtitle="It may have been deleted, or the link is wrong."
      />
      <Link
        to={copy.href}
        className="inline-flex items-center justify-center rounded-lg border border-line bg-white px-4 py-2.5 text-sm font-semibold text-ink no-underline hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/20"
      >
        {copy.back}
      </Link>
    </div>
  );
}
